document.addEventListener('DOMContentLoaded', function () {
  console.log(
    '%c Developed by XTO: Expertos Tiendas Online ',
    'background: blue; color: white; font-size: 17px;'
  );
  console.log('%c www.expertostiendasonline.es ', 'font-size: 17px;');

  function xto_closeAllMenus() {
    document.querySelectorAll('.x-menu--level-1--link').forEach(function (li) {
      li.setAttribute('data-state', 'closed');
      const trigger = li.querySelector('a[aria-haspopup="true"]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      const submenu = li.querySelector('.x-menu--level-2--container');
      if (submenu) {
        submenu.setAttribute('aria-hidden', 'true');
        submenu.style.setProperty('--height', '0px');
        submenu.style.display = 'none';
      }
    });
  }

  document.querySelectorAll('.x-menu--level-1--link').forEach(function (li) {
    const trigger = li.querySelector('a[aria-haspopup="true"]');
    const submenu = li.querySelector('.x-menu--level-2--container');

    if (!trigger || !submenu) return;

    li.addEventListener('mouseenter', function () {
      xto_closeAllMenus();
      li.setAttribute('data-state', 'open');
      trigger.setAttribute('aria-expanded', 'true');
      submenu.setAttribute('aria-hidden', 'false');
      submenu.style.display = 'flex';
      submenu.style.setProperty('--height', 'var(--natural-height)');
    });

    li.addEventListener('mouseleave', function () {
      li.setAttribute('data-state', 'closed');
      trigger.setAttribute('aria-expanded', 'false');
      submenu.setAttribute('aria-hidden', 'true');
      submenu.style.setProperty('--height', '0px');
      submenu.style.display = 'none';
    });
  });

  const accordionButtons = document.querySelectorAll('.y-menu--accordion-toggle');

  accordionButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      const submenuId = button.getAttribute('data-toggle');
      const content = document.getElementById(submenuId);

      if (!content) return;

      const isOpen = content.classList.contains('open');

      // Reset todos los acordeones
      document.querySelectorAll('.y-menu--accordion-content').forEach(function (el) {
        el.classList.remove('open');
        el.setAttribute('hidden', '');
      });

      // Reset estado de botones
      accordionButtons.forEach(function (btn) {
        btn.classList.remove('active');
        btn.setAttribute('aria-expanded', 'false');
      });

      // Abrir solo si estaba cerrado
      if (!isOpen) {
        content.classList.add('open');
        content.removeAttribute('hidden');
        button.classList.add('active');
        button.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // Menú Velas
  document.querySelectorAll('#x-menu--sub-mega_menu_anMWYh .x-menu--level-2--count-0 .x-menu--level-3--link .x-menu--subtitle')
    .forEach(function (subtitle) {
      subtitle.addEventListener('mouseenter', function () {
        const parent = this.closest('.x-menu--level-3--link')
        const level4 = this.nextElementSibling

        if (!level4 || !level4.classList.contains('x-menu--level-4--container')) {
          return
        }

        const container = parent.closest('.x-menu--level-3--container')

        container.querySelectorAll('.x-menu--subtitle.is-open').forEach(function (item) {
          item.classList.remove('is-open')
        })

        container.querySelectorAll('.x-menu--level-4--container.is-open').forEach(function (item) {
          item.classList.remove('is-open')
        })

        this.classList.add('is-open')
        level4.classList.add('is-open')
      })
    })

  // Menú Ambientadores
  document.querySelectorAll('#x-menu--sub-mega_menu_FEQyei .x-menu--level-3--link .x-menu--subtitle')
    .forEach(function (subtitle) {
      subtitle.addEventListener('mouseenter', function () {
        const level4 = this.nextElementSibling
        if (level4 && level4.classList.contains('x-menu--level-4--container')) {
          this.classList.toggle('is-open')
          level4.classList.toggle('is-open')
        }
      })
    })

  // Leer más en descripción prodcutos
  const toggles = document.querySelectorAll("toggle-ellipsis");

  toggles.forEach((toggle) => {
    const button = toggle.querySelector("[data-button]");
    const span = button?.querySelector("span");
    const actions = toggle.querySelector("[data-actions]");
    if (!button || !span || !actions) return;

    const textMore = actions.dataset.more || "Leer más";
    const textLess = actions.dataset.less || "Leer menos";

    button.addEventListener("click", () => {
      toggle.classList.toggle("is-open");

      if (toggle.classList.contains("is-open")) {
        span.textContent = textLess;
      } else {
        span.textContent = textMore;
      }
    });
  });

  // Carrito
  (function () {
    const originalFetch = window.fetch;

    window.fetch = async (...args) => {
      const [url, options] = args;
      const isCartRequest = url.includes('/cart/');

      const response = await originalFetch(...args);

      if (isCartRequest) {
        const clone = response.clone();

        try {
          const data = await clone.json();
          const cartForm = document.getElementById('cart-form');
          const cartBody = document.getElementById('cart-body');
          if (!cartForm || !cartBody) return response;

          // El endpoint devuelve item_count directamente
          if (typeof data.item_count !== 'undefined') {
            if (data.item_count === 0) {
              cartBody.innerHTML = '';
              cartForm.classList.add('is-empty');
            } else {
              cartForm.classList.remove('is-empty');
            }
          }

          // Al añadir un producto (no tiene item_count) → pedimos /cart.js
          else if (url.includes('/cart/add.js')) {
            const cart = await fetch(window.Shopify.routes.root + 'cart.js').then((r) => r.json());
            if (cart.item_count === 0) {
              cartBody.innerHTML = '';
              cartForm.classList.add('is-empty');
            } else {
              cartForm.classList.remove('is-empty');
            }
          }

        } catch (err) {}
      }

      return response;
    };
  })();



});

